import { reactive, Ref, ref } from 'vue';
import { SubFormData } from '@/components/view/pm/set-old-resident-dialog/all.type';
import { user } from '@/methods/rule';
import { isCNServer } from '@/util/location';
import residentApi from '@/api/pm/resident';

const initForm = (
    opera: 'add'|'edit',
    subFormData: SubFormData,
    mainId: string,
    emit: any
) => {
    const formEle: Ref<any> = ref();
    const formData = ref<SubFormData>({
        FirstName: '',
        LastName: '',
        Email: '',
        PhoneCode: isCNServer() ? '86' : '',
        MobileNumber: '',
        Phone: '',
        ID: mainId
    });

    if (opera === 'edit') {
        formData.value = {
            ...subFormData,
            Email: subFormData.Email || '',
            MobileNumber: subFormData.MobileNumber || ''
        };
    }

    const rules: {
        [key in string]: any[]
    } = reactive({
        FirstName: [{ required: true, message: WordList.RuleCommonLabelEmpty2.format(WordList.TabelPropertyManageFirstName), trigger: 'blur' }],
        LastName: [{ required: true, message: WordList.RuleCommonLabelEmpty2.format(WordList.TabelPropertyManageLastName), trigger: 'blur' }],
        Email: [],
        MobileNumber: []
    });

    rules.Email = formData.value.Email === '' ? [{ validator: user.checkEmail, trigger: 'blur' }] : [{
        required: true,
        message: WordList.RuleEmailEmpty,
        trigger: 'blur'
    }, {
        validator: user.checkEmail,
        trigger: 'blur'
    }];
    rules.MobileNumber = formData.value.MobileNumber === '' ? [] : [{
        required: true,
        message: WordList.RuleCommonLabelEmpty2.format(WordList.ProperAllTextMobileNumber),
        trigger: 'blur'
    }];

    const submit = () => {
        formEle.value.validate((valid: boolean) => {
            if (valid) {
                if (opera === 'add') {
                    residentApi.addSubForOldPm(formData.value, [(res: {
                        msg: string;
                        ID: string;
                        Active: number;
                        TipCode: 0|1;
                    }) => {
                        emit('submit', res);
                    }, false]);
                } else {
                    residentApi.editSubForOldPm(formData.value, () => {
                        emit('submit');
                    });
                }
            }
            return true;
        });
    };

    return {
        submit,
        formData,
        rules,
        formEle
    };
};

export default initForm;